<app-lista-arquivos [categoria]="categoria" [acao]="acao" ></app-lista-arquivos>
